import React, { useState } from 'react';
import { getAreaDisabledDataRanges } from '../../components/helper';
import { CommonInfo } from '../quant/QuantitativeObjectiveManagement';
import DimQuantitativeSamplesTable from './DimQuantitativeSamplesTable';
import DimQuantitativeSampleEditForm from '../../components/samples/DimQuantitativeSampleEditForm';

const DimQuantitativeSamplesManagement = ({ areaIndicator, onRefresh = null }) => {
    const [showSampleEditForm, setShowSampleEditForm] = useState(false);
    const [sampleSelected, setSampleSelected] = useState(null);

    const disabledDateRanges = getAreaDisabledDataRanges(areaIndicator.area);

    const handleSampleClick = (sample) => {
        setSampleSelected(sample);
        setShowSampleEditForm(true);
    };

    const handleSavedQuantitativeSample = (sample) => {
        setShowSampleEditForm(false);
        onRefresh && onRefresh();
    };

    const handleDeletedQuantitativeSample = (sample) => {
        setShowSampleEditForm(false);
        onRefresh && onRefresh();
    };

    return (
        <>
            <CommonInfo areaIndicator={areaIndicator} />
            <DimQuantitativeSamplesTable
                areaIndicator={areaIndicator}
                onSampleClick={handleSampleClick}
                onNewSample={() => {
                    setSampleSelected(null);
                    setShowSampleEditForm(true);
                }}
            />
            {
                showSampleEditForm &&
                <DimQuantitativeSampleEditForm
                    sample={sampleSelected}
                    planUUID={areaIndicator.area.plan.planUUID}
                    areaId={areaIndicator.area.areaId}
                    areaIndicatorId={areaIndicator.areaIndicatorId}
                    indicator={areaIndicator.indicatorDTO}
                    disabledDateRanges={disabledDateRanges}
                    onCancel={() => setShowSampleEditForm(false)}
                    onSave={handleSavedQuantitativeSample}
                    onDelete={handleDeletedQuantitativeSample}
                />
            }
        </>
    );
};

export default DimQuantitativeSamplesManagement;